import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../app/slices/posSlice";
import PosForm from "../../form";
import { MdPointOfSale } from "react-icons/md";
import PosServiceForm from "../posService";
import Permission from "../../../../components/userPermission/userPermission";

const PosHeader = () => {
  const dispatch = useDispatch();

  const _PointsOfsales = useSelector((state) => state.pointOfsales);
  const _PosService = useSelector((state) => state.service.addService.dialog);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            نقاط البيع
          </Typography>
        }
        avatar={<MdPointOfSale size={20} />}
        action={
          <Permission permission="pos_edit" role={["super_admin", "admin"]}>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة نقطة بيع جديدة
            </Button>
          </Permission>
        }
      />
      {_PointsOfsales.pos.dialog ? <PosForm inNeedReload={true} /> : null}
      {_PosService ? <PosServiceForm /> : null}
    </Card>
  );
};

export default PosHeader;
